import angular from 'angular';

angular.module('cloudX').filter('mimeIcon', [mimeIconFilter]);

function mimeIconFilter() {
  return function(mime) {
    if (!mime) return 'fa fa-file-o fa-fw';
    var parts = mime.toLowerCase().split('/');
    switch (parts[0]) {
      case 'text':
        if (parts.length === 1) return 'fa fa-file-text-o fa-fw';
        switch (parts[1]) {
          case 'html':
          case 'javascript':
          case 'css':
            return 'fa fa-file-code-o fa-fw';
          default:
            return 'fa fa-file-text-o fa-fw';
        }
      case 'application':
        if (parts.length === 1) return 'fa fa-file-o fa-fw';
        if (parts[1].indexOf('json') >= 0) return 'fa fa-file-code-o fa-fw';
        if (parts[1].indexOf('pdf') >= 0) return 'fa fa-file-pdf-o fa-fw';
        if (parts[1].indexOf('word') >= 0) return 'fa fa-file-word-o fa-fw';
        if (parts[1].indexOf('excel') >= 0) return 'fa fa-file-excel-o fa-fw';
        if (parts[1].indexOf('spreadsheet') >= 0) return 'fa fa-file-excel-o fa-fw';
        if (parts[1].indexOf('powerpoint') >= 0) return 'fa fa-file-powerpoint-o fa-fw';
        if (parts[1].indexOf('zip') >= 0) return 'fa fa-file-archive-o fa-fw';
        if (parts[1].indexOf('rar') >= 0) return 'fa fa-file-archive-o fa-fw';
        if (parts[1].indexOf('compressed') >= 0) return 'fa fa-file-archive-o fa-fw';
        if (parts[1].indexOf('xml') >= 0) return 'fa fa-file-code-o fa-fw';
        break;
      case 'image':
        return 'fa fa-file-image-o fa-fw';
      case 'audio':
        return 'fa fa-file-audio-o fa-fw';
      case 'video':
        return 'fa fa-file-video-o fa-fw';
    }

    return 'fa fa-file-o fa-fw';
  };
}
